const getMe = (apiGet) =>
  apiGet(`/me?$select=id,displayName,mail,mobilePhone,department&$expand=extensions`);

export default getMe;
